const actionTypes = {
	SET_LOADING: 'SET_LOADING',
	// SET_SELECTED_STEP: 'SET_SELECTED_STEP',
	SET_ENQUIRY: 'SET_ENQUIRY',
	// SET_BRANDS: 'SET_BRANDS',
	SET_ENQUIRY_QUOTE: 'SET_ENQUIRY_QUOTE',
	// SET_USERS: 'SET_USERS',
	CLEAR_NEW_STATE: 'CLEAR_NEW_STATE',
}

export const initialState = {
	loading: false,
	selectedStep: 1,
	enquiry: null,
	enquiryQuote: null,
	// brands: [],
	// users: [],
}

export const actions = {
	setLoading: (_loading) => ({
		type: actionTypes.SET_LOADING,
		loading: _loading,
	}),
	// setSelectedStep: (_selectedStep) => ({
	// 	type: actionTypes.SET_SELECTED_STEP,
	// 	selectedStep: _selectedStep,
	// }),
	setEnquiry: (_enquiry) => ({
		type: actionTypes.SET_ENQUIRY,
		enquiry: _enquiry,
	}),
	// setBrands: (_brands) => {
	// 	_brands = _brands.map((_b) => ({ id: _b, name: _b }))
	// 	return {
	// 		type: actionTypes.SET_BRANDS,
	// 		brands: _brands,
	// 	}
	// },
	setEnquiryQuote: (_enquiryQuote) => ({
		type: actionTypes.SET_ENQUIRY_QUOTE,
		enquiryQuote: _enquiryQuote,
	}),
	// setUsers: (users) => ({
	// 	type: actionTypes.SET_USERS,
	// 	users,
	// }),
	clearState: () => ({
		type: actionTypes.CLEAR_NEW_STATE,
	}),
}

export const reducer = (state, action) => {
	switch (action.type) {
		case actionTypes.SET_LOADING:
			return {
				...state,
				loading: action.loading,
			}

		// case actionTypes.SET_SELECTED_STEP:
		// 	return {
		// 		...state,
		// 		selectedStep: action.selectedStep,
		// 	}
		case actionTypes.SET_ENQUIRY:
			return {
				...state,
				enquiry: action.enquiry,
			}
		// case actionTypes.SET_BRANDS:
		// 	return {
		// 		...state,
		// 		brands: action.brands,
		// 	}
		case actionTypes.SET_ENQUIRY_QUOTE:
			return {
				...state,
				enquiryQuote: action.enquiryQuote,
			}
		// case actionTypes.SET_USERS:
		// 	return {
		// 		...state,
		// 		users: action.users,
		// 	}
		case actionTypes.CLEAR_NEW_STATE:
			return {
				...initialState,
			}

		default:
			return state
	}
}
